module.exports = __webpack_public_path__ + "static/media/yude-logo.ee3c7e40.png";